import {Selectors} from './selectors'

export default function getVariationsForm() {
  return document.querySelector<HTMLFormElement>(Selectors.form)
}
